import Anchor from '@oneflare/flarekit/lib/components/Anchor';
import ButtonLink from '@oneflare/flarekit/lib/components/ButtonLink';
import H2 from '@oneflare/flarekit/lib/components/H2';
import Paragraph from '@oneflare/flarekit/lib/components/Paragraph';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled } from 'styled-components';

export const ArticleWrapperStyled = styled.article`
  display: flex;
  flex-direction: column-reverse;
  margin: 0 0 40px;

  ${media.smUp`
    flex-direction: row;
    margin: 0;
  `}
`;

export const ArticleContentStyled = styled(Anchor)`
  display: block;

  &:hover {
    text-decoration: none;
  }
`;

export const ArticleHeaderStyled = styled(H2)`
  font-family: ${({ theme }) => theme.font.primaryRegular};
  color: ${({ theme }) => theme.color.charcoal};
  margin: 0 0 8px;
  font-weight: bold;
  font-size: 18px;

  &:hover {
    text-decoration: underline;
  }
`;

export const ExcerptStyled = styled(Paragraph)`
  white-space: pre-wrap;
  font-size: 16px;
`;

export const ArticleImageWrapperStyled = styled(Anchor)`
  display: block;
  margin: 0 0 32px;

  ${media.smUp`
    margin: 0 0 0 40px;
  `}

  ${media.lgUp`
    margin: 0 0 0 80px;
  `}
`;

export const ArticleImageStyled = styled.img`
  height: 260px;
  width: 100%;
  max-width: 100%;
  object-fit: cover;
  border-radius: 8px;

  ${media.smUp`
    width: 300px;
    min-width: 300px;
  `}

  ${media.lgUp`
    height: 268px;
    width: 344px;
    min-width: 344px;
  `}
`;

export const FindMoreStyled = styled(ButtonLink)`
  width: 168px;
  margin: 24px 0 0;

  ${media.smUp`
    margin: 32px 0 0;
  `}
`;
